// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17vqm","content":"styles_content__3tKeL"};